import { some } from "../../fable_modules/fable-library-js.4.18.0/Option.js";
import { class_type } from "../../fable_modules/fable-library-js.4.18.0/Reflection.js";
import * as react from "react";
import { notification } from "antd";

export class ConsoleNotifications {
    constructor() {
    }
    Send(level, title, message, _arg) {
        switch (level) {
            case "warning": {
                console.warn(some("%s %O"), title, message);
                break;
            }
            case "error": {
                console.error(some("%s %O"), title, message);
                break;
            }
            default:
                console.info(some("%s %O"), title, message);
        }
    }
}

export function ConsoleNotifications_$reflection() {
    return class_type("Loop54.Portal.WebUI.Services.Notifications.Notifications.ConsoleNotifications", undefined, ConsoleNotifications);
}

export function ConsoleNotifications_$ctor() {
    return new ConsoleNotifications();
}

class ReactNotifications {
    constructor(api) {
        this.api = api;
        this.consoleNotifications = ConsoleNotifications_$ctor();
    }
    Send(level, title, message, createNotificationContent) {
        const _ = this;
        _.consoleNotifications.Send(level, title, message);
        const arg = {
            description: (createNotificationContent == null) ? message : createNotificationContent(message),
            duration: ReactNotifications__duration_Z721C83C5(_, level),
            key: `${level}-${title}--${message}`,
            title: title,
        };
        switch (level) {
            case "info": {
                _.api.info(arg);
                break;
            }
            case "warning": {
                _.api.warning(arg);
                break;
            }
            case "error": {
                _.api.error(arg);
                break;
            }
            default:
                _.api.success(arg);
        }
    }
}

function ReactNotifications_$reflection() {
    return class_type("Loop54.Portal.WebUI.Services.Notifications.Notifications.ReactNotifications", undefined, ReactNotifications);
}

function ReactNotifications_$ctor_Z50A448BD(api) {
    return new ReactNotifications(api);
}

export function ReactNotifications__duration_Z721C83C5(this$, _arg) {
    switch (_arg) {
        case "warning":
        case "error":
            return false;
        default:
            return 5;
    }
}

export const Context = (() => {
    const defaultValue = ConsoleNotifications_$ctor();
    return react.createContext(defaultValue);
})();

/**
 * Call at the top level of the App component. Returns the contextHolder element to render inside
 * the React tree (must be inside StyleProvider) and the INotifications service to provide via Context.
 */
export function useReactNotifications(config) {
    const result = notification.useNotification(config);
    const notifService = react.useMemo(() => ReactNotifications_$ctor_Z50A448BD(result[0]), [result[0]]);
    return [result[1], notifService];
}

